import EventBgColorsData from "../../js/eventBgColorsData";
import {
  Animatespin,
  MainHeading,
  EventsCom,
  HoverButton,
  Footer,
  Navbar,
  Experience,
} from "../../components/index";
import Functions from "./index.function";
const MissionShe = () => {
  const {
    allMissionSHEData,
    additionalEvents,
    handleEvents,
    baseURL,
    isLoading,
    jobHasMorePages,
    setCurrentPage,
  } = Functions();
  return (
    <div className="bg-primary">
      <Navbar />
      <div className="lg:px-5 xl:px-10  sm:px-5 xs:px-3 m-auto xs:py-5">
        <MainHeading
          title={"MISSION SHE"}
          dis={" "}
          layout={"h-18 sm:h-20 lg:h-36"}
        />
        {allMissionSHEData?.projects?.length < 1 ? (
          <p className="text-secondary font-onestLight xs:text-xs sm:text-xs lg:text-sm text-center w-full sm:pt-6 pt-3">
            Data not available
          </p>
        ) : (
          <>
            <div className="xs:mt-5 sm:mt-8 grid xs:grid-cols-2 sm:grid-cols-4 xs:gap-2 sm:gap-5">
              {additionalEvents?.map((value, index) => (
                <div key={index}>
                  <EventsCom
                    onClick={() => handleEvents(value?.id)}
                    eventthubmail={`${baseURL}/uploads/mission_she/thumbnail/${value?.hero_image}`}
                    eventsimgClassName={"h-[65%]"}
                    eventsTextClassName={"h-[35%]"}
                    maxWClassname={"lg:max-w-60"}
                    textclassName={"lg:text-base"}
                    eventtheme={
                      EventBgColorsData[index % EventBgColorsData.length]
                        .eventtheme
                    }
                    eventTitle={value?.heading}
                    // evetDate={formatEventDate(value?.event_date)}
                    eventDis={value?.sub_heading}
                  />
                </div>
              ))}
            </div>

            {isLoading ? (
              <div className="xs:pt-1 sm:pt-2 lg:pt-3">
                <Animatespin />
              </div>
            ) : (
              <>
                {jobHasMorePages && (
                  <div
                    className={`flex justify-center items-center xs:pt-5 sm:pt-5 lg:pt-10`}
                  >
                    <HoverButton
                      onClick={() => setCurrentPage((prev) => prev + 1)}
                      extraClasses={
                        "group xs:w-56 xs:h-8 sm:w-60 sm:h-12 lg:w-64 bg-cover flex lg:h-12 items-center justify-center rounded-full transition-transform transform hover:scale-105 hover:shadow-md"
                      }
                      BtnTitle={"Load More Events"}
                      BtnTitleClasses={
                        "text-secondary font-onestSemiBold sm:text-sm lg:text-lg transition-transform transform group-hover:scale-110 group-hover:text-primary"
                      }
                    />
                  </div>
                )}
              </>
            )}
          </>
        )}
      </div>
      <Experience />
      <Footer />
    </div>
  );
};

export default MissionShe;
